function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*!
 * Signature Pad v3.0.0-beta.4 | https://github.com/szimek/signature_pad
 * (c) 2020 Szymon Nowak | Released under the MIT license
 */
var t = /*#__PURE__*/function () {
  function t(_t, e, i) {
    _classCallCheck(this, t);
    this.x = _t, this.y = e, this.time = i || Date.now();
  }
  return _createClass(t, [{
    key: "distanceTo",
    value: function distanceTo(_t2) {
      return Math.sqrt(Math.pow(this.x - _t2.x, 2) + Math.pow(this.y - _t2.y, 2));
    }
  }, {
    key: "equals",
    value: function equals(_t3) {
      return this.x === _t3.x && this.y === _t3.y && this.time === _t3.time;
    }
  }, {
    key: "velocityFrom",
    value: function velocityFrom(_t4) {
      return this.time !== _t4.time ? this.distanceTo(_t4) / (this.time - _t4.time) : 0;
    }
  }]);
}();
var e = /*#__PURE__*/function () {
  function e(t, _e, i, o, s, n) {
    _classCallCheck(this, e);
    this.startPoint = t, this.control2 = _e, this.control1 = i, this.endPoint = o, this.startWidth = s, this.endWidth = n;
  }
  return _createClass(e, [{
    key: "length",
    value: function length() {
      var t,
        _e3,
        i = 0;
      for (var o = 0; o <= 10; o += 1) {
        var s = o / 10,
          n = this.point(s, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x),
          h = this.point(s, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
        if (o > 0) {
          var _o = n - t,
            _s = h - _e3;
          i += Math.sqrt(_o * _o + _s * _s);
        }
        t = n, _e3 = h;
      }
      return i;
    }
  }, {
    key: "point",
    value: function point(t, _e4, i, o, s) {
      return _e4 * (1 - t) * (1 - t) * (1 - t) + 3 * i * (1 - t) * (1 - t) * t + 3 * o * (1 - t) * t * t + s * t * t * t;
    }
  }], [{
    key: "fromPoints",
    value: function fromPoints(t, i) {
      var o = this.calculateControlPoints(t[0], t[1], t[2]).c2,
        s = this.calculateControlPoints(t[1], t[2], t[3]).c1;
      return new e(t[1], o, s, t[2], i.start, i.end);
    }
  }, {
    key: "calculateControlPoints",
    value: function calculateControlPoints(_e2, i, o) {
      var s = _e2.x - i.x,
        n = _e2.y - i.y,
        h = i.x - o.x,
        a = i.y - o.y,
        r = (_e2.x + i.x) / 2,
        c = (_e2.y + i.y) / 2,
        l = (i.x + o.x) / 2,
        d = (i.y + o.y) / 2,
        u = Math.sqrt(s * s + n * n),
        v = Math.sqrt(h * h + a * a),
        _ = v / (u + v),
        m = l + (r - l) * _,
        p = d + (c - d) * _,
        w = i.x - m,
        g = i.y - p;
      return {
        c1: new t(r + w, c + g),
        c2: new t(l + w, d + g)
      };
    }
  }]);
}();
var i = /*#__PURE__*/function () {
  function i(t) {
    var _this = this;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, i);
    this.canvas = t, this.options = e, this._handleMouseDown = function (t) {
      1 === t.which && (_this._mouseButtonDown = !0, _this._strokeBegin(t));
    }, this._handleMouseMove = function (t) {
      _this._mouseButtonDown && _this._strokeMoveUpdate(t);
    }, this._handleMouseUp = function (t) {
      1 === t.which && _this._mouseButtonDown && (_this._mouseButtonDown = !1, _this._strokeEnd(t));
    }, this._handleTouchStart = function (t) {
      if (t.preventDefault(), 1 === t.targetTouches.length) {
        var _e5 = t.changedTouches[0];
        _this._strokeBegin(_e5);
      }
    }, this._handleTouchMove = function (t) {
      t.preventDefault();
      var e = t.targetTouches[0];
      _this._strokeMoveUpdate(e);
    }, this._handleTouchEnd = function (t) {
      if (t.target === _this.canvas) {
        t.preventDefault();
        var _e6 = t.changedTouches[0];
        _this._strokeEnd(_e6);
      }
    }, this.velocityFilterWeight = e.velocityFilterWeight || .7, this.minWidth = e.minWidth || .5, this.maxWidth = e.maxWidth || 2.5, this.throttle = "throttle" in e ? e.throttle : 16, this.minDistance = "minDistance" in e ? e.minDistance : 5, this.dotSize = e.dotSize || function () {
      return (this.minWidth + this.maxWidth) / 2;
    }, this.penColor = e.penColor || "black", this.backgroundColor = e.backgroundColor || "rgba(0,0,0,0)", this.onBegin = e.onBegin, this.onEnd = e.onEnd, this._strokeMoveUpdate = this.throttle ? function (t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
      var i,
        o,
        s,
        n = 0,
        h = null;
      var a = function a() {
        n = Date.now(), h = null, i = t.apply(o, s), h || (o = null, s = []);
      };
      return function () {
        var c = Date.now(),
          l = e - (c - n);
        for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
          r[_key] = arguments[_key];
        }
        return o = this, s = r, l <= 0 || l > e ? (h && (clearTimeout(h), h = null), n = c, i = t.apply(o, s), h || (o = null, s = [])) : h || (h = window.setTimeout(a, l)), i;
      };
    }(i.prototype._strokeUpdate, this.throttle) : i.prototype._strokeUpdate, this._ctx = t.getContext("2d"), this.clear(), this.on();
  }
  return _createClass(i, [{
    key: "clear",
    value: function clear() {
      var t = this._ctx,
        e = this.canvas;
      t.fillStyle = this.backgroundColor, t.clearRect(0, 0, e.width, e.height), t.fillRect(0, 0, e.width, e.height), this._data = [], this._reset(), this._isEmpty = !0;
    }
  }, {
    key: "fromDataURL",
    value: function fromDataURL(t) {
      var _this2 = this;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _i = arguments.length > 2 ? arguments[2] : undefined;
      var o = new Image(),
        s = e.ratio || window.devicePixelRatio || 1,
        n = e.width || this.canvas.width / s,
        h = e.height || this.canvas.height / s;
      this._reset(), o.onload = function () {
        _this2._ctx.drawImage(o, 0, 0, n, h), _i && _i();
      }, o.onerror = function (t) {
        _i && _i(t);
      }, o.src = t, this._isEmpty = !1;
    }
  }, {
    key: "toDataURL",
    value: function toDataURL() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "image/png";
      var e = arguments.length > 1 ? arguments[1] : undefined;
      switch (t) {
        case "image/svg+xml":
          return this._toSVG();
        default:
          return this.canvas.toDataURL(t, e);
      }
    }
  }, {
    key: "on",
    value: function on() {
      this.canvas.style.touchAction = "none", this.canvas.style.msTouchAction = "none", window.PointerEvent ? this._handlePointerEvents() : (this._handleMouseEvents(), "ontouchstart" in window && this._handleTouchEvents());
    }
  }, {
    key: "off",
    value: function off() {
      this.canvas.style.touchAction = "auto", this.canvas.style.msTouchAction = "auto", this.canvas.removeEventListener("pointerdown", this._handleMouseDown), this.canvas.removeEventListener("pointermove", this._handleMouseMove), document.removeEventListener("pointerup", this._handleMouseUp), this.canvas.removeEventListener("mousedown", this._handleMouseDown), this.canvas.removeEventListener("mousemove", this._handleMouseMove), document.removeEventListener("mouseup", this._handleMouseUp), this.canvas.removeEventListener("touchstart", this._handleTouchStart), this.canvas.removeEventListener("touchmove", this._handleTouchMove), this.canvas.removeEventListener("touchend", this._handleTouchEnd);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._isEmpty;
    }
  }, {
    key: "fromData",
    value: function fromData(t) {
      var _this3 = this;
      this.clear(), this._fromData(t, function (_ref) {
        var t = _ref.color,
          e = _ref.curve;
        return _this3._drawCurve({
          color: t,
          curve: e
        });
      }, function (_ref2) {
        var t = _ref2.color,
          e = _ref2.point;
        return _this3._drawDot({
          color: t,
          point: e
        });
      }), this._data = t;
    }
  }, {
    key: "toData",
    value: function toData() {
      return this._data;
    }
  }, {
    key: "_strokeBegin",
    value: function _strokeBegin(t) {
      var e = {
        color: this.penColor,
        points: []
      };
      "function" == typeof this.onBegin && this.onBegin(t), this._data.push(e), this._reset(), this._strokeUpdate(t);
    }
  }, {
    key: "_strokeUpdate",
    value: function _strokeUpdate(t) {
      if (0 === this._data.length) return void this._strokeBegin(t);
      var e = t.clientX,
        _i2 = t.clientY,
        o = this._createPoint(e, _i2),
        s = this._data[this._data.length - 1],
        n = s.points,
        h = n.length > 0 && n[n.length - 1],
        a = !!h && o.distanceTo(h) <= this.minDistance,
        r = s.color;
      if (!h || !h || !a) {
        var _t5 = this._addPoint(o);
        h ? _t5 && this._drawCurve({
          color: r,
          curve: _t5
        }) : this._drawDot({
          color: r,
          point: o
        }), n.push({
          time: o.time,
          x: o.x,
          y: o.y
        });
      }
    }
  }, {
    key: "_strokeEnd",
    value: function _strokeEnd(t) {
      this._strokeUpdate(t), "function" == typeof this.onEnd && this.onEnd(t);
    }
  }, {
    key: "_handlePointerEvents",
    value: function _handlePointerEvents() {
      this._mouseButtonDown = !1, this.canvas.addEventListener("pointerdown", this._handleMouseDown), this.canvas.addEventListener("pointermove", this._handleMouseMove), document.addEventListener("pointerup", this._handleMouseUp);
    }
  }, {
    key: "_handleMouseEvents",
    value: function _handleMouseEvents() {
      this._mouseButtonDown = !1, this.canvas.addEventListener("mousedown", this._handleMouseDown), this.canvas.addEventListener("mousemove", this._handleMouseMove), document.addEventListener("mouseup", this._handleMouseUp);
    }
  }, {
    key: "_handleTouchEvents",
    value: function _handleTouchEvents() {
      this.canvas.addEventListener("touchstart", this._handleTouchStart), this.canvas.addEventListener("touchmove", this._handleTouchMove), this.canvas.addEventListener("touchend", this._handleTouchEnd);
    }
  }, {
    key: "_reset",
    value: function _reset() {
      this._lastPoints = [], this._lastVelocity = 0, this._lastWidth = (this.minWidth + this.maxWidth) / 2, this._ctx.fillStyle = this.penColor;
    }
  }, {
    key: "_createPoint",
    value: function _createPoint(e, _i3) {
      var o = this.canvas.getBoundingClientRect();
      return new t(e - o.left, _i3 - o.top, new Date().getTime());
    }
  }, {
    key: "_addPoint",
    value: function _addPoint(t) {
      var _i4 = this._lastPoints;
      if (_i4.push(t), _i4.length > 2) {
        3 === _i4.length && _i4.unshift(_i4[0]);
        var _t6 = this._calculateCurveWidths(_i4[1], _i4[2]),
          o = e.fromPoints(_i4, _t6);
        return _i4.shift(), o;
      }
      return null;
    }
  }, {
    key: "_calculateCurveWidths",
    value: function _calculateCurveWidths(t, e) {
      var _i5 = this.velocityFilterWeight * e.velocityFrom(t) + (1 - this.velocityFilterWeight) * this._lastVelocity,
        o = this._strokeWidth(_i5),
        s = {
          end: o,
          start: this._lastWidth
        };
      return this._lastVelocity = _i5, this._lastWidth = o, s;
    }
  }, {
    key: "_strokeWidth",
    value: function _strokeWidth(t) {
      return Math.max(this.maxWidth / (t + 1), this.minWidth);
    }
  }, {
    key: "_drawCurveSegment",
    value: function _drawCurveSegment(t, e, _i6) {
      var o = this._ctx;
      o.moveTo(t, e), o.arc(t, e, _i6, 0, 2 * Math.PI, !1), this._isEmpty = !1;
    }
  }, {
    key: "_drawCurve",
    value: function _drawCurve(_ref3) {
      var t = _ref3.color,
        e = _ref3.curve;
      var _i7 = this._ctx,
        o = e.endWidth - e.startWidth,
        s = 2 * Math.floor(e.length());
      _i7.beginPath(), _i7.fillStyle = t;
      for (var _t7 = 0; _t7 < s; _t7 += 1) {
        var _i8 = _t7 / s,
          n = _i8 * _i8,
          h = n * _i8,
          a = 1 - _i8,
          r = a * a,
          c = r * a;
        var l = c * e.startPoint.x;
        l += 3 * r * _i8 * e.control1.x, l += 3 * a * n * e.control2.x, l += h * e.endPoint.x;
        var d = c * e.startPoint.y;
        d += 3 * r * _i8 * e.control1.y, d += 3 * a * n * e.control2.y, d += h * e.endPoint.y;
        var u = Math.min(e.startWidth + h * o, this.maxWidth);
        this._drawCurveSegment(l, d, u);
      }
      _i7.closePath(), _i7.fill();
    }
  }, {
    key: "_drawDot",
    value: function _drawDot(_ref4) {
      var t = _ref4.color,
        e = _ref4.point;
      var _i9 = this._ctx,
        o = "function" == typeof this.dotSize ? this.dotSize() : this.dotSize;
      _i9.beginPath(), this._drawCurveSegment(e.x, e.y, o), _i9.closePath(), _i9.fillStyle = t, _i9.fill();
    }
  }, {
    key: "_fromData",
    value: function _fromData(e, _i10, o) {
      var _iterator = _createForOfIteratorHelper(e),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var s = _step.value;
          var _e7 = s.color,
            n = s.points;
          if (n.length > 1) for (var _o2 = 0; _o2 < n.length; _o2 += 1) {
            var _s2 = n[_o2],
              h = new t(_s2.x, _s2.y, _s2.time);
            this.penColor = _e7, 0 === _o2 && this._reset();
            var a = this._addPoint(h);
            a && _i10({
              color: _e7,
              curve: a
            });
          } else this._reset(), o({
            color: _e7,
            point: n[0]
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "_toSVG",
    value: function _toSVG() {
      var _this4 = this;
      var t = this._data,
        e = Math.max(window.devicePixelRatio || 1, 1),
        _i11 = this.canvas.width / e,
        o = this.canvas.height / e,
        s = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      s.setAttribute("width", this.canvas.width.toString()), s.setAttribute("height", this.canvas.height.toString()), this._fromData(t, function (_ref5) {
        var t = _ref5.color,
          e = _ref5.curve;
        var _i12 = document.createElement("path");
        if (!(isNaN(e.control1.x) || isNaN(e.control1.y) || isNaN(e.control2.x) || isNaN(e.control2.y))) {
          var _o3 = "M ".concat(e.startPoint.x.toFixed(3), ",").concat(e.startPoint.y.toFixed(3), " C ").concat(e.control1.x.toFixed(3), ",").concat(e.control1.y.toFixed(3), " ").concat(e.control2.x.toFixed(3), ",").concat(e.control2.y.toFixed(3), " ").concat(e.endPoint.x.toFixed(3), ",").concat(e.endPoint.y.toFixed(3));
          _i12.setAttribute("d", _o3), _i12.setAttribute("stroke-width", (2.25 * e.endWidth).toFixed(3)), _i12.setAttribute("stroke", t), _i12.setAttribute("fill", "none"), _i12.setAttribute("stroke-linecap", "round"), s.appendChild(_i12);
        }
      }, function (_ref6) {
        var t = _ref6.color,
          e = _ref6.point;
        var _i13 = document.createElement("circle"),
          o = "function" == typeof _this4.dotSize ? _this4.dotSize() : _this4.dotSize;
        _i13.setAttribute("r", o.toString()), _i13.setAttribute("cx", e.x.toString()), _i13.setAttribute("cy", e.y.toString()), _i13.setAttribute("fill", t), s.appendChild(_i13);
      });
      var n = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 ".concat(_i11, " ").concat(o, "\" width=\"").concat(_i11, "\" height=\"").concat(o, "\">");
      var h = s.innerHTML;
      if (void 0 === h) {
        var _t8 = document.createElement("dummy"),
          _e8 = s.childNodes;
        _t8.innerHTML = "";
        for (var _i15 = 0; _i15 < _e8.length; _i15 += 1) _t8.appendChild(_e8[_i15].cloneNode(!0));
        h = _t8.innerHTML;
      }
      return "data:image/svg+xml;base64," + btoa(n + h + "</svg>");
    }
  }]);
}();
export default i;